import axiosInstance from "./api_helper";

export const createReglement = async (reglement) => {
  try {
    const response = await axiosInstance.post('/api/reglements/fournisseur', JSON.stringify(reglement));
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateReglement = async (id, reglement) => {
  try {
    const response = await axiosInstance.put(`/api/reglements/fournisseur/${id}`, JSON.stringify(reglement));
    return response;
  } catch (error) {
    throw error;
  }
};

export const getReglementsByFournisseur = async (fournisseurId, page = 0, size = 20, sortBy = 'dateReglement', sortDirection = 'desc') => {
  try {
    const response = await axiosInstance.get(`/api/reglements/fournisseur/by-fournisseur/${fournisseurId}`, {
      params: { page, size, sortBy, sortDirection }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getReglements = async (params = {}) => {
  try {
    const response = await axiosInstance.get('/api/reglements/fournisseur', { params });
    return response;
  } catch (error) {
    throw error;
  }
};

export const rechercherReglements = async ({ fournisseurId, companyId, dateFrom, dateTo, statut, query }) => {
  try {
    const params = {};
    if (fournisseurId !== undefined && fournisseurId !== null) params.fournisseurId = fournisseurId;
    if (companyId !== undefined && companyId !== null) params.companyId = companyId;
    if (dateFrom) params.dateFrom = dateFrom;
    if (dateTo) params.dateTo = dateTo;
    if (statut) params.statut = statut;
    if (query) params.query = query;

    const response = await axiosInstance.get('/api/reglements/fournisseur/rechercher', { params });

    return response;
  } catch (error) {
    throw error;
  }
};

export const annulerReglement = async (id) => {
  try {
    const response = await axiosInstance.delete(`/api/reglements/fournisseur/${id}/annuler`);
    return response;
  } catch (error) {
    throw error;
  }
};


export const getEcheancesFournisseurs = async ({ fournisseurId, dateFrom, dateTo, statut, modeReglement }) => {
  try {
    const params = {};
    if (fournisseurId !== undefined && fournisseurId !== null) params.fournisseurId = fournisseurId;
    if (dateFrom) params.dateFrom = dateFrom;
    if (dateTo) params.dateTo = dateTo;
    if (statut) params.statut = statut;
    if (modeReglement) params.mode = modeReglement;
    const response = await axiosInstance.get('/api/reglements/fournisseur/echeance', { params });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getCautionsFournisseurs = async ({ fournisseurId, dateFrom, dateTo, statut }) => {
  try {
    const params = {};
    if (fournisseurId !== undefined && fournisseurId !== null) params.fournisseurId = fournisseurId;
    if (dateFrom) params.dateFrom = dateFrom;
    if (dateTo) params.dateTo = dateTo;
    if (statut) params.statut = statut;
    const response = await axiosInstance.get('/api/reglements/fournisseur/caution', { params });
    return response;
  } catch (error) {
    throw error;
  }
};

export const decaisserReglement = async (id, decaissement) => {
  try {
    const response = await axiosInstance.post(`/api/reglements/fournisseur/${id}/decaisser`, JSON.stringify(decaissement));
    return response;
  } catch (error) {
    throw error;
  }
}

export const getReglementsByInvoice = async (numero) => {
  const params = {};
  if (numero) params.numero = numero;
  return await axiosInstance.get(`/api/reglements/fournisseur/facture`, { params });
};

export const solderImpaye = async (reglId) => {
  return await axiosInstance.get(`/api/reglements/fournisseur/solder/${reglId}`);
};

export const getReglementById = async (id) => {
  try {
    const response = await axiosInstance.get(`/api/reglements/fournisseur/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteReglement = async (id) => {
  try {
    const response = await axiosInstance.delete(`/api/reglements/fournisseur/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

